module.exports = __webpack_public_path__ + "static/media/facebook.ef7f10f4.svg";